<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To Account
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="accountGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";

import accountImage from "@/assets/howto/account/account.png";
import accountInformationImage from "@/assets/howto/account/account-information.png";
import accountStatusImage from "@/assets/howto/account/account-status.png";
import accountPermissions from "@/assets/howto/account/account-permissions.png";
import accountActions from "@/assets/howto/account/account-actions.png";
import accountPassword from "@/assets/howto/account/account-change-password.png";
import accountDelete from "@/assets/howto/account/account-delete.png";



export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToAccount: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToAccount : showHowTo.value;
    }); 

    const accountGuidePages = ref([
        {
            heading: "Account Overview",
            upperText: [
              "Mivu User Account Overview"
            ],
            image: accountImage,
            imageAlt: null,
            lowerText: [
              "From the main navigation menu, click on Account",
              "You will see the Account overview page showing your account"
            ]
        },
        {
            heading: "Account Information",
            upperText: [
                "This is an overview of the users's account details"
            ],
            image: accountInformationImage,
            imageAlt: "Mivu landing homepage",
            lowerText: []
        },
        {
            heading: "Account Status",
            upperText: [
              "Overview of the user's account status"
            ],
            image: accountStatusImage,
            imageAlt: "Home Refresh and Tutorial screenshot",
            lowerText: []
        },
        {
            heading: "Account Permissions",
            upperText: [
              "This section contains a complete list of the permissions currently assigned to a user"
            ],
            image: accountPermissions,
            imageAlt: "Dashboard Sections selection screenshot",
            lowerText: [],
        },
        {
            heading: "Account Actions",
            upperText: [
              "On the bottom of the Account Page there are two buttons, 'Change Password' and 'Delete Account'",
            ],
            image: accountActions,
            imageAlt: "Dashboard Sections selection screenshot",
            lowerText: [],
        },
        {
            heading: "Change Password",
            upperText: [
              "A change password modal with password requirements."
            ],
            image: accountPassword,
            imageAlt: "Dashboard Sections selection screenshot",
            lowerText: [],
        },
        {
            heading: "Delete Account",
            upperText: [
              "A delete account confirmation modal. If an account is deleted, it cannot be recovered."
            ],
            image: accountDelete,
            imageAlt: "Dashboard Sections selection screenshot",
            lowerText: [],
        },
        ]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    }

    return {
      showHowTo,
      accountGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>